module.exports = __webpack_public_path__ + "static/media/1-1-Z-ducha-sv-pocala.3bf65b3f.jpg";